import { MobileIcon, StudioPlatformIcon, WebPlatformIcon } from "icons";

const studioObj = {
  title: "Studio",
  icon: StudioPlatformIcon,
  bgColor: "#FFFAED",
};
const webObj = {
  title: "Web",
  icon: WebPlatformIcon,
  bgColor: "#E7FFC5",
};
const mobileObj = {
  title: "Mobile",
  icon: MobileIcon,
  bgColor: "#EDFDFF",
};
export const availableData = {
  Trial: {
    months: "4 Weeks",
    monthsLabel: "4 Weeks Plan",
    subscriptionId: 1,
    planName: "Trial",
    platforms: [mobileObj],
  },
  Basic: {
    months: "3 Months",
    monthsLabel: "3 Months Plan",
    subscriptionId: 2,
    planName: "Basic",
    platforms: [mobileObj],
  },
  Standard: {
    months: "6 Months",
    monthsLabel: "6 Months Plan",
    subscriptionId: 3,
    planName: "Standard",
    platforms: [webObj, mobileObj],
  },
  Premium: {
    months: "12 Months",
    monthsLabel: "12 Months Plan",
    subscriptionId: 4,
    planName: "Premium",
    platforms: [studioObj, webObj, mobileObj],
  },
};
